"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Toast_1 = tslib_1.__importStar(require("./Toast"));
var show_1 = require("../../utils/show");
function default_1(config) {
    return show_1.showWithTransition({
        Component: Toast_1.default,
        transitionDuration: Toast_1.TOAST_TRANSITION_DURATION,
        autoClose: true,
        props: config,
        contexts: config.contexts,
    });
}
exports.default = default_1;
